import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
var constructDownloadUrl = function constructDownloadUrl(canvases, currentCanvas, manifestUrl) {
  var _manifestUrl$match, _currentCanvas$id$mat, _canvases$0$id$match, _canvases$id$match;
  var url = new URL("https://download.digitale-sammlungen.de/BOOKS/download.pl");
  var objectId = (_manifestUrl$match = manifestUrl.match(/\/(bsb[^/]+)\/manifest/)) === null || _manifestUrl$match === void 0 ? void 0 : _manifestUrl$match[1];
  if (!objectId) {
    return null;
  }
  if (objectId.includes("_u")) {
    var _objectId$split = objectId.split("_");
    objectId = _objectId$split[0];
  }
  url.searchParams.set("id", objectId);
  var canvasPattern = /\/canvas\/([1-9][0-9]*)/;
  var currentPage = (_currentCanvas$id$mat = currentCanvas.id.match(canvasPattern)) === null || _currentCanvas$id$mat === void 0 ? void 0 : _currentCanvas$id$mat[1];
  if (currentPage) {
    url.searchParams.set("nr", currentPage);
  }
  var firstPage = (_canvases$0$id$match = canvases[0].id.match(canvasPattern)) === null || _canvases$0$id$match === void 0 ? void 0 : _canvases$0$id$match[1];
  if (firstPage) {
    url.searchParams.set("ersteseite", firstPage);
  }
  var lastPage = (_canvases$id$match = canvases[canvases.length - 1].id.match(canvasPattern)) === null || _canvases$id$match === void 0 ? void 0 : _canvases$id$match[1];
  if (lastPage) {
    url.searchParams.set("letzteseite", lastPage);
  }
  return url;
};
var PdfDafoLink = function PdfDafoLink(_ref) {
  var _theme$typography$fon;
  var canvases = _ref.canvases,
    manifestUrl = _ref.manifestUrl,
    t = _ref.t,
    visibleCanvases = _ref.visibleCanvases;
  var theme = useTheme();
  var downloadUrl = constructDownloadUrl(canvases, visibleCanvases[0], manifestUrl);
  if (!downloadUrl) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Card, {
    className: "mb-3",
    raised: true
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    component: "h5",
    style: {
      textTransform: "none"
    },
    variant: "h6"
  }, /*#__PURE__*/React.createElement(Box, {
    fontWeight: "fontWeightBold"
  }, t("wholeDocument"))), /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(ListItem, {
    dense: true
  }, /*#__PURE__*/React.createElement(Box, {
    fontFamily: (_theme$typography$fon = theme.typography.fontFamily) !== null && _theme$typography$fon !== void 0 ? _theme$typography$fon : "sans-serif",
    fontSize: "0.75rem"
  }, /*#__PURE__*/React.createElement(Link, {
    href: downloadUrl,
    target: "_blank"
  }, "PDF/DaFo")))))));
};
PdfDafoLink.propTypes = process.env.NODE_ENV !== "production" ? {
  canvases: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })).isRequired,
  manifestUrl: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  visibleCanvases: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })).isRequired
} : {};
export default PdfDafoLink;